<div class="kine-form">

  <!-- ── Affection + Praticien ── -->
  <div class="row g-2 mb-3">
    <div class="col-6">
      <label class="dent-label">Affection</label>
      <ng-select [items]="itemsAffection" bindLabel="libelle" bindValue="id"
        [(ngModel)]="itemToSave.affection_id" placeholder="Sélectionnez l'affection" [searchable]="true">
      </ng-select>
    </div>
    <div class="col-6">
      <label class="dent-label">Praticien</label>
      <ng-select [items]="itemsPraticien" bindLabel="full_name" bindValue="id"
        [(ngModel)]="itemToSave.praticien_id" placeholder="Sélectionnez le praticien" [searchable]="true">
      </ng-select>
    </div>
  </div>

  <!-- ── Actes à réaliser ── -->
  <div class="mb-3">
    <label class="dent-label">Actes à réaliser</label>
    <div class="mb-2 d-flex align-items-center gap-2">
      <div class="flex-grow-1">
        <ng-select [items]="itemsActe" bindLabel="libelle" [(ngModel)]="selectedActeItem"
          placeholder="Sélectionner un acte" [searchable]="true" [loading]="loadingActes"
          [disabled]="loadingTarif" (change)="onAddItemToList()">
        </ng-select>
      </div>
      <div *ngIf="loadingTarif" class="d-flex align-items-center gap-1 text-primary"
        style="font-size:0.75rem;white-space:nowrap">
        <span class="spinner-border spinner-border-sm"></span> Chargement tarif...
      </div>
    </div>

    <div class="acte-list-wrap" style="overflow-x:auto">
      <table class="table table-sm mb-0"
        style="--bs-table-cell-padding-x:0.4rem;--bs-table-cell-padding-y:0.22rem;font-size:0.75rem;min-width:600px">
        <thead class="custom-table-head">
          <tr>
            <th style="width:30px">#</th>
            <th>Examen</th>
            <th style="width:80px">Séances</th>
            <th style="width:90px">Montant</th>
            <th style="width:90px">Part patient</th>
            <th style="width:90px">Part assurance</th>
            <th style="width:34px"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of itemsElement; let i = index" [ngClass]="{
            'table-warning': item.is_entente_prealable,
            'table-danger': item.is_exclu,
            'table-success': !item.is_exclu && !item.is_entente_prealable
          }">
            <td>{{ i + 1 }}</td>
            <td>{{ item.acte_libelle }}</td>
            <td>
              <input type="number" class="form-control form-control-sm text-end" style="width:70px"
                [(ngModel)]="item.quantite" min="1" (change)="onQuantiteChange(item)">
            </td>
            <td class="text-end">{{ item.montant | moneyFormat }}</td>
            <td class="text-end">{{ item.part_patient | moneyFormat }}</td>
            <td class="text-end">{{ item.part_assurance | moneyFormat }}</td>
            <td>
              <button class="btn btn-sm btn-outline-danger" (click)="itemsElement.splice(i, 1)">✕</button>
            </td>
          </tr>
          <tr *ngIf="!itemsElement.length">
            <td colspan="7" class="text-center text-muted py-2" style="font-size:0.75rem">
              <i class="fas fa-info-circle me-1"></i>Aucun acte ajouté
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ── Footer ── -->
  <div class="dent-footer">
    <button [disabled]="!itemsElement?.length" (click)="confirmSaveItem(itemToSave)"
      class="btn btn-success btn-sm px-4">
      <i class="fas fa-paper-plane me-1"></i>Enregistrer la prescription
    </button>
  </div>

</div><!-- /kine-form -->
